import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

import {nodeAnatomy} from './anatomy';
import {contentNodeSize} from './config';
import {$borderColor} from './css-vars';

const {definePartsStyle} = createMultiStyleConfigHelpers(nodeAnatomy);
const style = definePartsStyle(({highlight}) => {
  return {
    container: {
      // TODO: consume from css-vars
      ...contentNodeSize,
      // TODO This breaks the legacy semantic tokens usage
      [$borderColor.variable]: highlight ? `colors.${highlight}.500` : `colors.gray.300`,
      boxShadow: `md`,
    },
    header: {
      display: `flex`,
      flexDirection: `row`,
      alignItems: `center`,
      justifyContent: `space-between`,
      gap: `16`,
    },
    heading: {
      overflow: `hidden`,
      textOverflow: `ellipsis`,
    },
    body: {
      overflow: `hidden`,
      textOverflow: `ellipsis`,
      whiteSpace: `nowrap`,
    },
  };
});

export default style;
